import { useQuery } from '@tanstack/react-query';

import { QueryKey } from ':cloud/queries/types';
import { APIClient } from ':cloud/state/Api';
import { ICluster } from ':cloud/types/ts_types';

async function fetchResources(resourceId: string): Promise<{ resource: ICluster }> {
  const path = `/v1/resources/${resourceId}`;
  const { data } = await APIClient.get<{ resource: ICluster }>(path);
  return data;
}

export function useGetResource(resourceId: string): {
  isLoading: boolean;
  resource?: ICluster;
} {
  const { isLoading, data } = useQuery({
    queryKey: [QueryKey.resources, resourceId],
    queryFn: async () => fetchResources(resourceId),
    staleTime: Infinity,
    retry: 3,
    enabled: !!resourceId,
  });

  return {
    isLoading,
    resource: data?.resource,
  };
}
